import { EqlFieldCommonMetadataSourceListTooltip } from '@modules/common/components/EqlFieldCommonMetadataInfo/EqlFieldCommonMetadataSourceListTooltip';
import { Box, Stack, TooltipProps, Typography } from '@mui/material';
import { EqlField } from 'generated/graphql';

const MAX_SOURCES_TO_SHOW = 3;

interface EqlFieldCommonMetadataSourceIconsProps {
  eqlField: EqlField;
  tooltipPlacement?: TooltipProps['placement'];
  shouldHideTooltip?: boolean;
}

export const EqlFieldCommonMetadataSourceIcons = ({
  eqlField,
  tooltipPlacement = 'top',
  shouldHideTooltip = false,
}: EqlFieldCommonMetadataSourceIconsProps) => {
  const isCommonMetadataField = eqlField.detail?.metadata?.source === 'Common';

  if (!isCommonMetadataField) {
    return null;
  }

  const metadataReferences = eqlField.detail?.metadata?.references;

  if (!metadataReferences?.length) {
    return null;
  }

  const renderSourceIcons = () => {
    return (
      <Stack direction="row" alignItems="center" spacing={0.5}>
        {metadataReferences
          .slice(0, MAX_SOURCES_TO_SHOW)
          .map((metadataReference) => {
            return (
              <Box
                key={metadataReference.key}
                component="img"
                width="16px"
                height="auto"
                src={metadataReference.iconURL}
                alt={metadataReference.source}
                loading="lazy"
              />
            );
          })}
        {metadataReferences.length > MAX_SOURCES_TO_SHOW && (
          <Typography variant="body2" color="text.secondary">
            +{metadataReferences.length - MAX_SOURCES_TO_SHOW}
          </Typography>
        )}
      </Stack>
    );
  };

  if (shouldHideTooltip) {
    return renderSourceIcons();
  }

  return (
    <>
      <EqlFieldCommonMetadataSourceListTooltip
        eqlField={eqlField}
        placement={tooltipPlacement}
      >
        {renderSourceIcons()}
      </EqlFieldCommonMetadataSourceListTooltip>
    </>
  );
};
